import { useQuery } from "@tanstack/react-query";
import { getDossierOriginOption } from "../../../api/service/customerbaseApi";
import { Controller, useFormContext } from "react-hook-form";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useTranslation } from "react-i18next";
import { CustomerSearchFilters } from "../../../types";

const CBDossierOriginSearchFilter = () => {

    const { t } = useTranslation('customerbase');
    const formContext = useFormContext<CustomerSearchFilters>();

    const dossierOriginQuery = useQuery({
        queryKey: ["getDossierOriginOption"],
        queryFn: getDossierOriginOption,
        enabled: false
    });

    const handleOnOpen = () => {
        if(dossierOriginQuery.data == undefined) 
            dossierOriginQuery.refetch();
    }

    const formatOriginIdentifierOptions = (data: string[]): string[] => {
        if (data == undefined || data == null) return [];
        const modifiedOriginIdentifiers: string[] = data.map((originIdentifier) =>{
            if (originIdentifier.includes('DBE')) {
                return 'USER';
            }
            return originIdentifier;
        });
        return ['', ...modifiedOriginIdentifiers];
    }

    const getDisplayValue = (fieldValue: string | undefined | null): string | undefined | null => {
        if (fieldValue === 'DBE') return 'USER';
        return fieldValue;
    }

    const handleOriginIdentifierChange = (
        value: string | null,
        onChange: (value: string | null) => void
    )=> {
        value === 'USER' ? onChange('DBE') : onChange(value)
    }

    return (
        <Controller
            name={"dossierOrigin"}
            control={formContext.control}
            render={({ field}) =>
                <Autocomplete
                    fullWidth
                    openOnFocus
                    autoHighlight
                    autoSelect
                    options={formatOriginIdentifierOptions(dossierOriginQuery.data!)}
                    value={getDisplayValue(field.value)}
                    onOpen={handleOnOpen}
                    loading={dossierOriginQuery.isLoading}
                    onChange={(_e, value) => {
                        handleOriginIdentifierChange(value, field.onChange);
                    }}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={t("dossierOrigin")}
                            fullWidth
                        />
                    } />
            }
        />
    )

}

export default CBDossierOriginSearchFilter;